import { render, staticRenderFns } from "./NewsTab.vue?vue&type=template&id=60ce0827&scoped=true&"
import script from "./NewsTab.vue?vue&type=script&lang=js&"
export * from "./NewsTab.vue?vue&type=script&lang=js&"
import style0 from "./NewsTab.vue?vue&type=style&index=0&id=60ce0827&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce0827",
  null
  
)

export default component.exports